
import axios from 'axios';
import { decodeToken } from '../../components/utils/decodeToken/decodeToken';

const apiUrl = process.env.REACT_APP_API_URL;

export const getMyCropsLast = async () => {
    try {
        const token = decodeToken(localStorage.getItem('user-jwt'))
        const response = await axios.get(`${apiUrl}/crops/own`, {
            params: {
                idUser: token.sub,
            },
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error al obtener información de cultivos: ', error);
        throw error;
    }
};

export const getCropDetails = async (cropId) => {
    try {
        const response = await axios.get(`${apiUrl}/crops/own/${cropId}`, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response.data;
    } catch (error) {
        console.error(`Error fetching details for crop ${cropId}:`, error);
        throw error;
    }
};

export const renameCrop = async (cropId, name) => {
    const response = await axios.patch(`${apiUrl}/crops/${cropId}/name`, { name }, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
        },
    });
    return response.data;
};

// Deprecated: getMyCrops was a mock function. Keeping loosely for now if needed by other components, but ideally should be removed.
export const getMyCrops = async () => {
    return getMyCropsLast();
};
